import { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router';
import {
  convertDataToString,
  convertLocationSearchToDataStringParams,
  convertParsedQsToLiterals,
  ParsedQsConversionOptions,
} from 'utilities/queryString';

export const useQueryStringQuery = <T>(
  myUrlString: string,
  defaultQuery: T,
  excludeInString: Array<keyof T> = [],
  parsedQsOptions?: ParsedQsConversionOptions
) => {
  const history = useHistory();
  const queryObject = useMemo<T>(() => {
    const allParams = convertParsedQsToLiterals(
      convertLocationSearchToDataStringParams(history.location.search),
      parsedQsOptions
    );
    return {
      pageNumber: 0,
      pageSize: 10,
      ...defaultQuery,
      ...allParams,
    };
  }, [history.location.search, defaultQuery, parsedQsOptions]);

  const queryKey = useMemo(() => convertDataToString(queryObject), [queryObject]);

  const setQueryObject = useCallback(
    (x: T) => {
      const rest: Partial<T> = {
        ...x,
      };
      excludeInString.forEach((t) => (rest[t] = undefined));
      history.push(`${myUrlString}?${convertDataToString(rest)}`);
    },
    [history, myUrlString, excludeInString]
  );

  return { queryKey, queryObject, setQueryObject };
};
